define('views/pages/trade/index',['require','jquery','underscore','chaplin','mediator','models/base/model','views/base/page','lib/utils','views/dialog','views/pages/trade/offer/index','models/pages/trade/basket-item','views/pages/trade/request/index','text!templates/pages/trade/index.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        Chaplin = require('chaplin'),
        mediator = require('mediator'),
        Model = require('models/base/model'),
        PageView = require('views/base/page'),
        utils = require('lib/utils'),
        Dialog = require('views/dialog'),
        TradeOfferView = require('views/pages/trade/offer/index'),
        BasketItemModel = require('models/pages/trade/basket-item'),
        TradeRequestView = require('views/pages/trade/request/index'),
        template = require('text!templates/pages/trade/index.ejs');

    function QuequeExec(fn) {
        var _this = this;
        this.queque = [];
        this.busy = false;
        this.fn = fn;

        this.interval = setInterval(function() {
            _this.check();
        }, 1000);
    }

    QuequeExec.prototype.check = function(immediate) {
        var _this = this;

        if (!this.queque) { return; }
        if (!immediate && this.busy) { return; }

        var data = this.queque.pop();

        if (data) {
            this.busy = true;
            this.fn(data, function() {
                _this.busy = false;
            });
        }
    };

    QuequeExec.prototype.add = function(data) {
        this.queque.push(data);
        this.check(true);
    };

    QuequeExec.prototype.dispose = function() {
        clearInterval(this.interval);
        this.interval = null;
        this.queque = null;
    };

    // TRADE

    var TradePageView = PageView.extend({
        autoRender: true,
        template: template,
        id: 'pages-trade-page',
        regions: {
            'trade-request-tab': '.tab-content',
            'trade-offer-tab': '.tab-content'
        },
        listen: {
            'addedToDOM': 'onAddedToDOM',
            'change:loading model': 'updateBreadcrumb'
        },
        windowResize: true,
        initialize: function() {
            PageView.prototype.initialize.apply(this, arguments);

            this.delegate('click', '#trade-tabs>.nav-tabs a', this.onChangeTabs);
            this.subscribeEvent('openOrgOfferCard', this.openOrgOfferCard);
            this.subscribeEvent('addToBasket', this.onAddToBasket);
            this.subscribeEvent('updateBasket', this.onUpdateBasket);
            this.subscribeEvent('removeFromBasket', this.onRemoveFromBasket);
            this.subscribeEvent('addToBasketMinLot', this.onAddToBasketMinLot);
            this.subscribeEvent('updateBasketByFlashOrder', this.onUpdateBasketByFlashOrder);
            this.subscribeEvent('repeatRequest', this.onRepeatRequest);

            this.basketQueque = new QuequeExec(_.bind(this.onProcessBasketQueque, this));
        },
        dispose: function() {
            if (this.disposed) { return; }
            this.basketQueque.dispose();
            PageView.prototype.dispose.apply(this, arguments);
        },
        onChangeTabs: function() {
            var _this = this;
            setTimeout(function() {
                // console.log('onChangeTags');

                if (_this.$('#trade-tabs>.nav-tabs .active a').attr('href') === '#trade-offer-tab') {
                    _this.model.set('page', 'offer');
                } else {
                    _this.model.set('page', 'request');
                }
                _this.model.trigger('resize');

                _this.updateURL();
            }, 100);
        },
        onAddedToDOM: function() {
            this.model.trigger('resize');
        },
        render: function() {
            PageView.prototype.render.apply(this, arguments);

            this.subview('trade-request-tab', new TradeRequestView({ model: this.model }));
            this.subview('trade-offer-tab', new TradeOfferView({ model: this.model }));

        },
        updateBreadcrumb: function() {
            var trade = this.model.get('trade');
            if (trade && trade.name) {
                mediator.setBreadcrumb(['schedule'], trade.name + ' ' + utils.fmtDisplayDate((new Date(trade.receiveDate)).getTime()));
            }
        },
        openOrgOfferCard: function (model) {
            var itemT, itemB, _this = this;

            var idOrganizationOffer = model.get('idOrganizationOffer');

            if (this.model.items === model.collection) {
                // from tg
                itemT = model.getAttributes();
                itemB = this.model.basket.findWhere({ idOrganizationOffer: idOrganizationOffer });
            } else {
                itemB = model;
                itemT = _.findWhere(this.model.filter.get('source'), { idOrganizationOffer: idOrganizationOffer });
            }

            Chaplin.mediator.execute('openGoodsCard', {
                title: itemT.fullName,
                tradeId: this.model.get('tradeId'),
                organizationOfferId: itemT.idOrganizationOffer,
                tradeGoodsId: itemT.id,
                basketId: itemB ? itemB.get('id') : null
            });
        },

        onProcessBasketQueque: function(data, next) {
            var _this = this;
            this.onAddToBasketMinLot(data, true)
                .then(function() {
                    // _this.publishEvent('addToBasket', data);
                    // console.log('2.!!');
                    next();
                }, function() {
                    // console.log('1.!!');
                    next();
                });
        },

        onRepeatRequest: function(selection, cancel) {

            if (!this.model.canBuy()) {
                return cancel();
            }

            // console.log('repeatRequest!!', selection);

            var _this = this;
            var items = this.model.filter.get('source');
            var selected, itemT, message, notFound = [];


            for (var i=0, li=selection.length; i<li; i++) {
                selected = selection[i];

                itemT = _.findWhere(items, { idOrganizationOffer: selected.idOrganizationOffer });

                if (itemT) {
                    this.basketQueque.add(_.merge(
                        _.clone(itemT),
                        {
                            amount: selected.amount,
                            comment: selected.comment
                        }
                    ));
                } else {
                    notFound.push(selected);
                }
            }
            if (notFound.length) {
                // console.log('not found records', notFound);

                if (notFound.length < selection.length) {
                    message = 'Часть товара не может быть добавлена в корзину, т.к. отсутствует в предложениях на данной торговой площадке. Для уточнения деталей свяжитесь с Вашим менеджером.';
                } else {
                    message = 'Товар не может быть добавлен в корзину, т.к. отсутствует в предложениях на данной торговой площадке. Для уточнения деталей свяжитесь с Вашим менеджером.';
                }

                Dialog.show('Добавление в корзину', message, Dialog.Buttons.Close);
            }
        },

        onAddToBasketMinLot: function(itemT, noAdd){
            itemT = _.cloneDeep(itemT);
            var _this = this;
            var find;

            // console.log('addToBasketMinLot:', arguments);

            itemT.idTradeGoods = itemT.idTradeGoods ? itemT.idTradeGoods : (itemT.id ? itemT.id : null);
            itemT.id = null;

            find = this.model.basket.findWhere({
                idTradeGoods: itemT.idTradeGoods,
                idOrganizationOffer: itemT.idOrganizationOffer
            });

            if (!noAdd) {
                itemT.amount = itemT.minLot;
            }

            itemT.idTrade = this.model.get('tradeId');
            itemT.price = itemT.traderBasePrice;

            itemT.idMainChain = this.model.get('idMainChain');
            itemT.idAddChain = this.model.get('idAddChain');

            var basketModel = new BasketItemModel(itemT);

            if(find){
                if (!noAdd) {
                    itemT.amount += find.get('amount');
                }
                return basketModel.save({}, { success: function(model){
                    _this.onUpdateBasket(itemT);
                } });
            }else{
                return basketModel.save({}, { success: function(model){
                    itemT.id = model.get('id');
                    _this.onAddToBasket(itemT);
                } });
            }
        },
        onRemoveFromBasket: function(itemT){
            var find;

            // console.log('onRemoveFromBasket:', arguments);

            find = this.model.basket.findWhere({
                idTradeGoods: itemT.idTradeGoods,
                idOrganizationOffer: itemT.idOrganizationOffer
            });

            if(find){
                this.model.basket.remove(find);
            }
        },
        onUpdateBasket: function(itemT){
            var find;

            // console.log('onUpdateBasket:', arguments);

            find = this.model.basket.findWhere({
                idTradeGoods: itemT.idTradeGoods,
                idOrganizationOffer: itemT.idOrganizationOffer
            });

            if(find){
                find.set('amount', itemT.amount);
                find.set('comment', itemT.comment);
            }

            this.publishEvent('selectTradeRow', itemT);
        },
        onAddToBasket: function(itemT) {
            var find;

            // console.log('onAddToBasket:', arguments);

            find = this.model.basket.findWhere({
                idTradeGoods: itemT.idTradeGoods,
                idOrganizationOffer: itemT.idOrganizationOffer
            });

            if (!find) {
                find = this.model.basket.add(_.extend({
                    id: itemT.id,
                    idTradeGoods: itemT.idTradeGoods,
                    idOrganizationOffer: itemT.idOrganizationOffer,
                    amount: itemT.amount,
                    minLot: itemT.minLot,
                    price: itemT.traderBasePrice,
                    unit: itemT.unit,
                    fullName: itemT.fullName,
                    traderViewPrice: itemT.traderViewPrice,
                    traderViewCurrency: itemT.viewCurrency,
                    viewCurrency: itemT.viewCurrency,
                    comment: itemT.comment,
                    koefVolume: itemT.koefVolume,
                    koefPercent: itemT.koefPercent,
                    koefWeight: itemT.koefWeight,
                    idMainChain: this.model.get('idMainChain'),
                    idAddChain: this.model.get('idAddChain')
                }));

            } else {
                find.set('amount', itemT.amount);
            }

            this.publishEvent('selectTradeRow', itemT);
        },
        onUpdateBasketByFlashOrder: function(itemT){
            // console.log('onUpdateBasketByFlashOrder', itemT);
            var find, _this = this;
            if(typeof itemT === 'object'){
                find = this.model.basket.findWhere({
                    idTradeGoods: itemT.idTradeGoods,
                    idOrganizationOffer: itemT.idOrganizationOffer
                });
                if(find){
                    this.model.basket.remove(find);
                }
            }else{
                if(itemT){
                    var basketItemsId = itemT.split(',');
                    if(basketItemsId.length > 0){
                        basketItemsId.forEach(function(id){
                            find = _this.model.basket.findWhere({
                                id: parseInt(id, 10)
                            });
                            if(find){
                                _this.model.basket.remove(find);
                            }
                        });
                    }
                }else{
                    this.model.basket.reset();
                }
            }
        },
        updateURL: function() {
            var state = [];
            var model = this.model;

            if (model.get('stateOM')) { state.push('om'); }
            if (model.get('stateON')) { state.push('on'); }
            if (model.get('stateFO')) { state.push('fo'); }
            if (model.get('stateSO')) { state.push('so'); }
            //???

            utils.changeURL('trade#show', {
                tradeId: model.get('tradeId'),
                state: model.get('state'),
                page: model.get('page')
            }, {
                state: state
            });
        }
    });

    return TradePageView;
});

